import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
};

export const api = {
  get: (path, params) => axios.get(`${API}${path}`, { params }).then((r) => r.data),
  post: (path, data) => axios.post(`${API}${path}`, data).then((r) => r.data),
};

const adminClient = () => {
  const token = localStorage.getItem("bm_admin_token");
  return axios.create({
    baseURL: `${API}/apadmin`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const adminApi = {
  get: (path, params) => adminClient().get(path, { params }).then((r) => r.data),
  post: (path, data) => adminClient().post(path, data).then((r) => r.data),
  put: (path, data) => adminClient().put(path, data).then((r) => r.data),
  patch: (path, data) => adminClient().patch(path, data).then((r) => r.data),
  delete: (path) => adminClient().delete(path).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return adminClient().post("/upload", fd).then((r) => r.data);
  },
};

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
